import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../../components/loader";
import buildLink from "../../../urls";
import MessageAlert from "../../../components/messageAlert";
import hocStarredPage from "../../../components/hocStarredPage";
import { CompanyContext } from "../../../contexts/companyCotext";
import { PlaySounds } from "../../../functions/playSounds";
import Cookies from "js-cookie";
import { axiosServer } from "../../../axiosServer";

const SendToControlv2 = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const history = useNavigate();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [returnInf, setReturnInf] = useState(null);
  const codePr = useRef(null);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const commentRef = useRef(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);

  const searchReturn = async (e) => {
    setLoadingSearch(true);
    e.preventDefault();

    const item = codePr.current.value;

    try {
      const url =
        buildLink("returnOrderProduct") + `&return_order_product_id=${item}`;
      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          setReturnInf(response.data.data);
          setMessage(response.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        }
        if (response.data.data.status_id == 27) {
          setMessage("This Product is already in Control");
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }
      });
      setLoadingSearch(false);
    } catch (e) {
      console.log(e);
      setLoadingSearch(false);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
    setLoadingSearch(false);
  };

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  async function handleSave() {
    const userID = getUserIdFromLocalStorage()
    const url = buildLink("updateReturnOrderProduct");
    const return_order_product_id = codePr.current.value;
    const return_status_id = 27;
    const user_id = userID;
    const comment = commentRef.current.value;
    const type = "";

    const obj = {
      return_order_product_id,
      return_status_id,
      comment,
      type,
      user_id,
    };

    try {
      await axiosServer.put(url, obj).then((res) => {
        if (res.data.success) {
          playSuccessSound();
          setMessage(res.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        }
      });
    } catch (e) {
      playErrorSound();
      setMessage(e.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }

  useEffect(() => {
    codePr.current.focus();
  }, []);

  const handleTrashClick = () => {
    codePr.current.value = "";
    codePr.current.focus();
  };
  return (
    <>
      <div className=" h-full  bg-white ">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Send To Control</h2>
            </div>
          </div>
        </div>

        <div className="container flex flex-col gap-5">

          <form onSubmit={(e) => searchReturn(e)}>
            <div className="mb-1">Rerturn Order ID</div>
            <div className=" flex flex-row justify-center gap-3 ">

              <div className="relative flex-1">
                <input
                  ref={codePr}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Rerturn Product ID"
                />
                <div>
                  <FaTrash
                    onClick={() => handleTrashClick()}
                    className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                  />
                </div>
              </div>
              <button className=" bg-dbase rounded-md text-white px-5 ">
                {" "}
                {loadingSearch ? <Loader /> : <FaSearch />}{" "}
              </button>
            </div>
          </form>

          {/* <div className="relative flex-1">
                <input
                  ref={prodcutPlace}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Product Place"
                />
                <div onClick={() => (prodcutPlace.current.value = "")}>
                  <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
                </div>
              </div> */}

          <div className="relative flex-1">
            <div className="mb-1">Comment</div>
            <input
              ref={commentRef}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Comment"
            />
            <div onClick={() => (commentRef.current.value = "")}>
              <FaTrash className="absolute top-[52px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
            </div>
          </div>

          <div className=" w-full  flex flex-row gap-3">
            {" "}
            <button
              onClick={() => {
                handleSave();
              }}
              className=" w-full py-2 bg-dbase text-white "
            >
              Send
            </button>{" "}
          </div>
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(SendToControlv2);
